import { PLL_LINKS } from '../Config/League/league.config'
import { TICKETMASTER_BASE_URL, TICKETMASTER_CAME_FROM } from '../Constants/tickets'

export const ROUTING_URLS = {
  TEAMS_URL: '/teams',
  PLAYERS_URL: '/players',
  PLAYER_STAT_LEADERS_URL: '/players',
  PLAYER_TABLE_URL: '/player-table',
  PLAYER_STATS_URL: '/player-table',
  TEAM_TABLE_URL: '/pll-team-table',
  ALL_TEAMS_TABLE_URL: '/team-table',
  ALL_TEAM_STATS_URL: '/team-table',
  GAMES_URL: '/games',
  CAREER_LEADERS_URL: '/career-leaders',
  ADVANCED_STATS_URL: '/advanced-stats',
  PLAYER_COMPARISON_URL: '/player-comparison',
  LOGIN_URL: '/login',
  FANTASY_URL: '/fantasy',
}

export type SeasonType = 'regular' | 'post' | 'allstar' | 'champseries'

/**
 *
 * Create UTM Link
 */

type ShopParams = {
  medium: string
  slug?: string
  campaign: string
}
export const createShopUTM = ({ medium, campaign, slug }: ShopParams) => {
  return `${PLL_LINKS.shop}/${
    slug && slug
  }?utm_source=Web_Main&utm_medium=${medium}&utm_campaign=${campaign}`
}

export const createPlayerShopUTM = ({ medium, campaign, slug }: ShopParams) => {
  return `${slug}?utm_source=Web_Main&utm_medium=${medium}&utm_campaign=${campaign}`
}

export const createRoyaleAppLink = (week?: string) => {
  if (!week) {
    return `https://pllmain.page.link/?pageID=PlayerRoyale&link=https://premierlacrosseleague.com/fantasy&ibi=com.pll.PLL&apn=com.pll.pllandroid&ifl=https://premierlacrosseleague.com/fantasy`
  } else {
    return `https://pllmain.page.link/?pageID=PlayerRoyale&link=https://premierlacrosseleague.com/fantasy&week=${week}&ibi=com.pll.PLL&apn=com.pll.pllandroid&ifl=https://premierlacrosseleague.com/fantasy`
  }
}

type TicketParams = {
  ticketId: string
}

export const createTicketUTM = ({ ticketId }: TicketParams) => {
  if (!ticketId.includes('.com')) {
    return `${TICKETMASTER_BASE_URL}/event/${ticketId}?${TICKETMASTER_CAME_FROM}`
  }
  if (ticketId.includes('ticketmaster')) return `${ticketId}?${TICKETMASTER_CAME_FROM}`
  return ticketId
}
